@if (isPrimaryView || !isNewPlaylistEnabled) {
  @if (isNewPlaylistEnabled && isPrimaryView) {
    <ol-post-text
      [item]="item()"
      [variant]="variant()"
      [isGuest]="isGuest()"
      [isMajiApp]="isMajiApp()"
      [openInSameWindow]="openInSameWindow()"
      (navigateToPost)="onPostClick()"
    >
      <button class="watch-film community-button primary" (click)="onPostClick()">
        <outlaw-icon class="icon-svg" name="playCircle" />
        Watch
      </button>
    </ol-post-text>
  } @else {
    <ol-post-text
      [item]="item()"
      [variant]="variant()"
      [isGuest]="isGuest()"
      [isMajiApp]="isMajiApp()"
      [openInSameWindow]="openInSameWindow()"
      (navigateToPost)="onPostClick()"
    ></ol-post-text>
  }
} @else {
  @if (loading()) {
    <app-community-loader />
  } @else {
    <div class="video-player">
      @if (loadingAccess()) {
        <app-community-loader />
      } @else {
        @if (canDisplayPreview) {
          <div class="preview-container">
            <img class="preview" [src]="preview" />
            @if (requiresSubscription) {
              <outlaw-subscribe-button
                class="subscribe"
                [isFreeVideo]="isFreeVideo"
                (subscribeClick)="
                  onSubscribeClick({
                    isFreeVideo: isFreeVideo,
                    isGuest: isGuest(),
                    isMajiApp: isMajiApp(),
                    isMobile: isMobile,
                  })
                "
              />
            }
          </div>
        } @else {
          <div class="trailer-video-container">
            <app-stream
              [loop]="loopVideo"
              class="trailer-video"
              [poster]="poster"
              [activatePlay]="activatePlay()"
              [watchedDuration]="0"
              [muted]="true"
              [streamUrl]="activeVideoToken"
              [controls]="canDisplayControls"
              (videoFinished)="onVideoFinished(selectedVideo, hasSubscription())"
              (videoPausedProgress)="onVideoProgress($event)"
              (sendVideoProgress)="addWatchProgress($event)"
            />

            @if (!canDisplayControls) {
              <div class="player-actions">
                <span class="player-control" (click)="mutedTrailer = !mutedTrailer">
                  @if (mutedTrailer) {
                    <outlaw-icon class="icon-muted" name="noSound" />
                  } @else {
                    <outlaw-icon class="icon-sound" name="sound" />
                  }
                </span>

                <span class="player-control" (click)="toggleFullscreen(selectedVideo, isMajiApp(), isMobile)">
                  <outlaw-icon class="icon-svg" name="fullScreen" />
                </span>
              </div>
            }

            @if (requiresSubscription) {
              <outlaw-subscribe-button
                class="subscribe"
                [isFreeVideo]="isFreeVideo"
                (subscribeClick)="
                  onSubscribeClick({
                    isFreeVideo: isFreeVideo,
                    isGuest: isGuest(),
                    isMajiApp: isMajiApp(),
                    isMobile: isMobile,
                  })
                "
              />
            }
          </div>
        }
      }
    </div>

    <div class="playlist-post-wrapper">
      @if (videos.length > 0) {
        <outlaw-playlist-carousel
          [videos]="videos"
          [selectedVideo]="selectedVideo"
          [carouselConfig]="carouselConfig"
          [canDisplayTrailerButton]="canDisplayTrailerButton"
          (videoClick)="onVideoClick($event)"
          (trailerClick)="toggleFullscreen(selectedVideo, isMajiApp(), isMobile)"
        ></outlaw-playlist-carousel>
      }

      <div class="info-block">
        <app-text-content
          [title]="item().content.title"
          [text]="item().content.text"
          [postUrl]="overrideUrl()"
          [openInSameWindow]="openInSameWindow()"
          (postClick)="onPostClick()"
        />
      </div>
    </div>
  }
}
